import { browserStorageGet } from '../../utils/storage';

interface FeedAction {
  payload: Record<keyof FeedState, FeedState[keyof FeedState]>;
  type: string;
}

interface FeedState {
  filter: string;
}

function getInitialState(): FeedState {
  // persisted by setFeedFilter; codes are validated against the panel's filters at read time (selectFeedFilter)
  const stored = browserStorageGet<unknown, string>('feedFilter', 'all');
  return { filter: typeof stored === 'string' && stored ? stored : 'all' };
}

export function feedReducer(state: FeedState = getInitialState(), action: FeedAction) {
  switch (action.type) {
    case 'feed/setFilter':
      return {
        ...state,
        filter: action.payload.filter,
      };

    default:
      return state;
  }
}
